import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Badge, Form } from 'react-bootstrap';
import { TabView, TabPanel } from 'primereact/tabview';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import moment from "moment";
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';
import { InputNumber } from 'primereact/inputnumber';
import { Calendar } from 'primereact/calendar';
import { RadioButton } from "primereact/radiobutton";
import { useAuth } from '../../context/AuthContext';
import axios from 'axios';
import config from '../../config';
import nouserImg from '../../assets/images/no_user.png';
import filedefault from '../../assets/images/client_right.png';
import CustomConfirmPopup from "../../components/CustomConfirmPopup";

const Employee_expense_Page = () => {
    const { accessToken, userId } = useAuth();
    const [ingredient, setIngredient] = useState('');
    const [visibleRight, setVisibleRight] = useState(false);
    const [expensesData, setExpensesData] = useState({ expenses: [], deductions: [] });
    const [dateRange, setDateRange] = useState({
        startDate: moment().startOf("month"), // Start of the current week (Sunday by default)
        endDate: moment().endOf("month"), // End of the current week (Saturday by default)
    });
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(false); // To track if editing or adding
    const [formData, setFormData] = useState({
        id: '', // Add the ID field
        user_id: userId,
        expense_amount: '',
        expense_reason: '',
        expense_type: 'Expense', // Default to 'Expense'
        date: '',
        expense_image: null,
        status: 'Pending', // Default status
    });

    const fetchExpenses = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/expensesRoutes//fetch-user-expenses/${userId}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`, // Add Authorization header
                },
                params: {
                    startDate: dateRange.startDate ? moment(dateRange.startDate).format("YYYY-MM-DD") : "",
                    endDate: dateRange.endDate ? moment(dateRange.endDate).format("YYYY-MM-DD") : "",
                },
            });
            setExpensesData(response.data.data);
        } catch (error) {
            console.error("Error fetching expenses:", error);
        } finally {
            setLoading(false);
        }
    };



    // Delete expense handler
    const handleDeleteExpense = async (id) => {

        try {
            const response = await axios.delete(`${config.apiBASEURL}/expensesRoutes/delete-employee-expense-pending/${id}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            fetchExpenses(); // Refresh the data
        } catch (error) {
            console.error("Error deleting expense:", error);
        }

    };


    const handleEdit = (expense) => {
        setEditMode(true);
        setFormData({
            id: expense.employee_expense_id, // Add the ID for editing
            user_id: expense.user_id,
            expense_amount: expense.expense_amount,
            expense_reason: expense.expense_reason,
            expense_type: expense.expense_type,
            date: moment(expense.date).toDate(),
            expense_image: null, // Reset file input
            status: expense.status,
        });
        setVisibleRight(true); // Open the sidebar
    };




    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setFormData((prev) => ({ ...prev, expense_image: e.target.files[0] }));
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append("user_id", formData.user_id);
        data.append("expense_amount", formData.expense_amount);
        data.append("expense_reason", formData.expense_reason);
        data.append("expense_type", formData.expense_type);
        data.append("date", moment(formData.date).format("YYYY-MM-DD"));
        data.append("status", formData.status); // Include status in API call
        if (formData.expense_image) {
            data.append("image", formData.expense_image);
        }

        try {
            if (editMode) {
                // Edit API call
                const response = await axios.put(
                    `${config.apiBASEURL}/expensesRoutes/edit-employee-expense-pending/${formData.id}`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

            } else {
                // Add API call
                const response = await axios.post(
                    `${config.apiBASEURL}/expensesRoutes/add-employee-expense`,
                    data,
                    {
                        headers: {
                            Authorization: `Bearer ${accessToken}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

            }

            setVisibleRight(false); // Close the sidebar
            fetchExpenses(); // Refresh the expense list
            setFormData({
                id: '', // Reset the ID field
                user_id: userId,
                expense_amount: '',
                expense_reason: '',
                expense_type: 'Expense',
                date: '',
                expense_image: null,
                status: 'Pending',
            }); // Reset form data
            setEditMode(false); // Reset edit mode
        } catch (error) {
            console.error("Error submitting expense:", error);

        } finally {
            setLoading(false);
        }
    };






    // Handle date range change
    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: start,
            endDate: end,
        });
    };

    useEffect(() => {
        fetchExpenses();
    }, [dateRange, accessToken]);

    return (
        <>
            <Row className="body_content">
                <Row className="mx-0">
                    <Col sm={12} xs={12} className="mb-4 d-lg-flex justify-content-between align-items-center">
                        <Breadcrumb>
                            <Breadcrumb.Item active>Employee Expenses</Breadcrumb.Item>
                        </Breadcrumb>
                        <div className="d-flex justify-content-end mt-3 mt-lg-0">
                            <DateRangePicker
                                initialSettings={{
                                    startDate: dateRange.startDate,
                                    endDate: dateRange.endDate,
                                    locale: { format: "DD/MM/YYYY" },
                                    ranges: {
                                        Today: [moment(), moment()],
                                        Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                        "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                        "Last 30 Days": [moment().subtract(29, "days"), moment()],
                                        "This Month": [moment().startOf("month"), moment().endOf("month")],
                                        "Last Month": [
                                            moment().subtract(1, "month").startOf("month"),
                                            moment().subtract(1, "month").endOf("month"),
                                        ],
                                    },
                                }}
                                onCallback={(start, end) => handleDateRangeChange(start, end)}
                            >
                                <input
                                    type="text"
                                    className="form-control mx-2"
                                    style={{ width: "200px" }}
                                    placeholder="Select Date Range"
                                />
                            </DateRangePicker>
                            <Button
                                label="Expense"
                                icon="pi pi-plus"
                                className="border-0"
                                severity="primary"
                                onClick={() => setVisibleRight(true)}
                            />
                        </div>

                    </Col>
                    <Col lg={12}>
                        <Card>
                            <TabView>
                                <TabPanel header="All Expenses">
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : (
                                        <div className="table-responsive resp_report">
                                            <Table hover size="sm">
                                                <thead className="table-primary sticky-top">
                                                    <tr>
                                                        <th>Employee</th>
                                                        <th>Image</th>
                                                        <th>Amount</th>
                                                        <th>Reason</th>
                                                        <th>Status</th>
                                                        <th>Issue Date</th>
                                                        <th style={{ width: "100px" }}>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expensesData.expenses.length > 0 ? (
                                                        expensesData.expenses.map((expense) => (
                                                            <tr key={expense.id}>
                                                                <td>
                                                                    <div className="d-flex align-items-center">
                                                                        <img
                                                                            src={
                                                                                expense.user.profileImage?.image_url ||
                                                                                nouserImg
                                                                            }
                                                                            alt="Profile"
                                                                            style={{ width: "30px", height: "30px" }}
                                                                            className="rounded-circle me-2"
                                                                        />
                                                                        {`${expense.user.first_name} ${expense.user.last_name}`}
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <Image
                                                                        src={expense.expense_image_url || filedefault} zoomSrc={expense.expense_image_url || filedefault} alt="Image" width="50" height="50" preview />
                                                                </td>
                                                                <td>₹{expense.expense_amount}</td>
                                                                <td>{expense.expense_reason}</td>
                                                                <td>
                                                                    <Badge
                                                                        className={`${expense.status === "Approved"
                                                                            ? "bg-success"
                                                                            : expense.status === "Pending"
                                                                                ? "bg-warning"
                                                                                : "bg-danger"
                                                                            }`}
                                                                    >
                                                                        {expense.status}
                                                                    </Badge>
                                                                </td>
                                                                <td>{moment(expense.date).format("DD/MM/YYYY")}</td>
                                                                <td>
                                                                    {expense.status === "Pending" && (
                                                                        <Button
                                                                            title="Edit"
                                                                            icon="pi pi-pencil"
                                                                            outlined
                                                                            className="border-0 p-0"
                                                                            severity="info"
                                                                            onClick={() => handleEdit(expense)} // Pass the selected expense
                                                                        />
                                                                    )}
                                                                    {expense.status === "Pending" && (
                                                                        <CustomConfirmPopup
                                                                            message="Are you sure you want to delete this expense?"
                                                                            icon="pi pi-exclamation-triangle"
                                                                            defaultFocus="accept"
                                                                            acceptClassName="p-button-danger"
                                                                            buttonLabel="Delete"
                                                                            title="Delete Expense"
                                                                            buttonClass="p-button-danger p-button-text"
                                                                            className="border-0 p-0"
                                                                            buttonIcon="pi pi-trash"
                                                                            onConfirm={() => handleDeleteExpense(expense.employee_expense_id)}
                                                                            onReject={() => console.log('Delete action canceled')}
                                                                        />
                                                                    )}
                                                                </td>
                                                            </tr>
                                                        ))
                                                    ) : (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">
                                                                No expenses available.
                                                            </td>
                                                        </tr>
                                                    )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    )}
                                </TabPanel>
                                <TabPanel header="Deductions">
                                    {loading ? (
                                        <p>Loading...</p>
                                    ) : expensesData.deductions.length > 0 ? (
                                        <div className="table-responsive resp_report">
                                            <Table hover size="sm">
                                                <thead className="table-primary sticky-top">
                                                    <tr>
                                                        <th>Employee</th>
                                                        <th>Image</th>
                                                        <th>Amount</th>
                                                        <th>Reason</th>
                                                        <th>Status</th>
                                                        <th>Issue Date</th>
                                                        {/* <th style={{ width: "100px" }}>Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expensesData.deductions.map((deduction) => (
                                                        <tr key={deduction.id}>
                                                            <td>
                                                                <div className="d-flex align-items-center">
                                                                    <img
                                                                        src={
                                                                            deduction.user.profileImage?.image_url ||
                                                                            nouserImg
                                                                        }
                                                                        alt="Profile"
                                                                        style={{ width: "30px", height: "30px" }}
                                                                        className="rounded-circle me-2"
                                                                    />
                                                                    {`${deduction.user.first_name} ${deduction.user.last_name}`}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <Image
                                                                    src={deduction.expense_image_url || filedefault} zoomSrc={deduction.expense_image_url || filedefault} alt="Image" width="50" height="50" preview />
                                                            </td>
                                                            <td>₹{deduction.expense_amount}</td>
                                                            <td>{deduction.expense_reason}</td>
                                                            <td>
                                                                <Badge
                                                                    className={`${deduction.status === "Approved"
                                                                        ? "bg-success"
                                                                        : deduction.status === "Pending"
                                                                            ? "bg-warning"
                                                                            : "bg-danger"
                                                                        }`}
                                                                >
                                                                    {deduction.status}
                                                                </Badge>
                                                            </td>
                                                            <td>{moment(deduction.date).format("DD/MM/YYYY")}</td>
                                                            {/* <td>
                                                                <Button
                                                                    title="Edit"
                                                                    icon="pi pi-pencil"
                                                                    outlined
                                                                    className="border-0 p-0"
                                                                    severity="info"
                                                                    onClick={() => handleEdit(deduction)} // Pass the selected expense
                                                                />
                                                                {deduction.status === "Pending" && (
                                                                    <CustomConfirmPopup
                                                                        message="Are you sure you want to delete this expense?"
                                                                        icon="pi pi-exclamation-triangle"
                                                                        defaultFocus="accept"
                                                                        acceptClassName="p-button-danger"
                                                                        buttonLabel="Delete"
                                                                        title="Delete Expense"
                                                                        buttonClass="p-button-danger p-button-text"
                                                                        className="border-0 p-0"
                                                                        buttonIcon="pi pi-trash"
                                                                        onConfirm={() => handleDeleteExpense(deduction.employee_expense_id)}
                                                                        onReject={() => console.log('Delete action canceled')}
                                                                    />
                                                                )}
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                    ) : (
                                        <p>No deductions available.</p>
                                    )}
                                </TabPanel>
                            </TabView>
                        </Card>
                    </Col>
                </Row>
            </Row>
            <Sidebar
                visible={visibleRight}
                position="right"
                onHide={() => {
                    setVisibleRight(false);
                    setEditMode(false); // Reset editMode
                    setFormData({
                        id: '', // Reset the ID field
                        user_id: userId,
                        expense_amount: '',
                        expense_reason: '',
                        expense_type: 'Expense', // Default to Expense
                        date: null,
                        status: 'Pending', // Default to Pending
                    }); // Reset formData to default
                }}
                style={{ width: "380px" }}
            >
                <h6 className="text-black">{editMode ? "Edit Expense" : "Add Expense"}</h6>
                <hr />
                <Form onSubmit={handleFormSubmit}>
                    <div className="mb-3">
                        <Form.Label>Upload Image</Form.Label>
                        <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            disabled={loading}
                        />
                    </div>
                    <div className="mb-3">
                        <Form.Label>Reason</Form.Label>
                        <Form.Control
                            as="textarea"
                            name="expense_reason"
                            rows={2}
                            value={formData.expense_reason}
                            onChange={handleInputChange}
                            disabled={loading}
                        />
                    </div>
                    <div className="mb-3">
                        <Form.Label>Amount</Form.Label>
                        <InputNumber
                            name="expense_amount"
                            value={formData.expense_amount}
                            onValueChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    expense_amount: e.value,
                                }))
                            }
                            min={0}
                            mode="decimal"
                            showButtonBar
                            currency="USD"
                            className="w-100"
                            locale="en-US"
                            disabled={loading}
                        />
                    </div>
                    <div className="mb-3">
                        <Form.Label>Date</Form.Label>
                        <Calendar
                            name="date"
                            value={formData.date}
                            onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    date: e.value,
                                }))
                            }
                            dateFormat="dd/mm/yy"
                            placeholder="Select Date"
                            disabled={loading}
                        />
                    </div>
                    {/* <div className="mb-3">
                        <Form.Label>Expense Type</Form.Label>
                        <div className="d-flex align-items-center">
                            <div className="flex align-items-center me-3">
                                <RadioButton
                                    inputId="expenseType1"
                                    name="expense_type"
                                    value="Deduction"
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            expense_type: e.value,
                                        })
                                    }
                                    checked={formData.expense_type === "Deduction"}
                                />
                                <label htmlFor="expenseType1" className="ms-2">
                                    Deduction
                                </label>
                            </div>
                            <div className="flex align-items-center">
                                <RadioButton
                                    inputId="expenseType2"
                                    name="expense_type"
                                    value="Expense"
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            expense_type: e.value,
                                        })
                                    }
                                    checked={formData.expense_type === "Expense"}
                                />
                                <label htmlFor="expenseType2" className="ms-2">
                                    Expense
                                </label>
                            </div>
                        </div>
                    </div> */}
                    <div className="d-flex justify-content-end">
                        <Button
                            label={loading ? "Loading..." : "Save"}
                            type="submit"
                            className="me-2 py-2"
                            severity="success"
                            disabled={loading}
                        />
                        <Button
                            label="Cancel"
                            className="py-2"
                            severity="danger"
                            type="button"
                            onClick={() => {
                                setVisibleRight(false);
                                setEditMode(false); // Reset editMode
                                setFormData({
                                    id: '', // Reset the ID field
                                    user_id: userId,
                                    expense_amount: '',
                                    expense_reason: '',
                                    expense_type: 'Expense', // Default to Expense
                                    date: null,
                                    status: 'Pending', // Default to Pending
                                }); // Reset formData to default
                            }}
                        />
                    </div>
                </Form>
            </Sidebar>
        </>
    );
}

export default Employee_expense_Page;
